import { render, staticRenderFns } from "./MilkIndex.vue?vue&type=template&id=194bbd8a&"
import script from "./MilkIndex.vue?vue&type=script&lang=js&"
export * from "./MilkIndex.vue?vue&type=script&lang=js&"
import style0 from "./MilkIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports